export default {
  Fafuli_Test: {
    TestButton: 'Test'
  }
}
